Vendd.Scripts.load(function () {

	function init(context) {
		var $context = $(context);
		var $wrapper = $('.x-warehouse-selector-popup-step-one_A', $context);

		if ($wrapper.length < 1) {
			return;
		}

		var wrapper = $wrapper.get(0),
			$root,
			$postCode,
			$error,
			$submitButton;

		var state = {
			postCode: undefined,
			validationError: undefined
		};

		wrapper.init = function () {
			$root = $('.warehouse-selector-popup-step-one', $wrapper);
			$postCode = $(':input[name="postcode"]', $root);
			$error = $('.js-error', $root);
			$submitButton = $('.js-submit', $root);

			state.postCode = $postCode.selectedVal() || '';
			state.validationError = false;

			wrapper.updateViewState();
		};

		wrapper.updateViewState = function () {
			$error.toggle(state.validationError);
			$submitButton.toggleDisabled(state.postCode === '' || state.validationError);
		};

		wrapper.loading = function (status) {
			if (status === undefined) {
				return $wrapper.hasClass('x-loading');
			} else {
				$wrapper.toggleClass('x-loading', status);
			}
		};

		wrapper.updatePostCode = function (value) {
			if (state.postCode !== value) {
				state.postCode = value;
				state.validationError = false;
				wrapper.updateViewState();
			}
		};

		$wrapper.on('click', '.js-submit', function (e) {
			e.preventDefault();
			wrapper.loading(true);
			Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.GetStoresByPostCode(
				state.postCode
			));
		});

		$wrapper.on('keyup', ':input[name="postcode"]', function (e) {
			e.preventDefault();
			wrapper.updatePostCode($postCode.val());
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresSuccess, wrapper, function () {
			wrapper.loading(false);
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresFailed, wrapper, function () {
			state.validationError = true;
			wrapper.updateViewState();
			wrapper.loading(false);
		});

		wrapper.init();
	}

	Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-warehouse-selector-popup-step-one_A', function (envelope) {
		if (envelope.message.data.context === 'x-warehouse-selector-popup') {
			init(envelope.sender);
		}
	});
});
